module.exports = __webpack_public_path__ + "img/face14.2a3adfe1.gif";